import React from 'react';
import styles from './nav-panel.module.scss';
import closeIcon from "../../content/assets/close-icon.svg"
import NavTab from './nav-tab';

class NavPanel extends React.Component {
  render() {
    const hiddenClass = this.props.isHidden ? ' ' + styles.hiddenPanel : '';
    return (
      <div className={styles.navPanel +
                      hiddenClass +
                      ' ' + (this.props.isFullScreen ? styles.fullScreenPanel : styles.sidePanel)
                     }>
        <img src={closeIcon} className={styles.closeButton + hiddenClass} onClick={this.props.closeClicked}/>
        <div className={styles.navPanelTitle}>
          <h3>THE<br/>POLITICAL<br/>HACK<br/>PROJECT<br/></h3>
        </div>
        <NavTab to={'/'} title={'Home'} />
        {/* forceActive is used so that /blog-post-name makes "Blog" appear active */}
        <NavTab to={'/blog/'} title={'Blog'} forceActive={this.props.isBlog} />
        <NavTab to={'/politicians/'} title={'Politicians'} />
        <NavTab to={'/donors/'} title={'Donors'} />
        <NavTab to={'/issues/'} title={'Issues'} />
        <NavTab to={'/investigate/'} title={'Investigate'} />
        <NavTab to={'/about-us/'} title={'About Us'} />
      </div>
    );
  }
}

export default NavPanel;